import { CollectorMake } from './components/fields/CollectorMake';
import { DriverListSelectCapital } from './components/fields/DriverListSelectCapital';
import { UMPDLimitSelector } from './components/fields/UMPDLimitSelector';
import { PDLimitSelector } from './components/fields/PDLimitSelector';
import { BILimitSelector } from './components/fields/BILimitSelector';
import { UMBILimitSelector } from './components/fields/UMBILimitSelector';
import { UIMBILimitSelector } from './components/fields/UIMBILimitSelector';
import { UMSUMLimitSelector } from './components/fields/UMSUMLimitSelector';
import { MPLimitSelector } from './components/fields/MPLimitSelector';
import { CollisionDeductibleSelector } from './components/fields/CollisionDeductibleSelector';
import { ILBLimitSelector } from './components/fields/ILBLimitSelector';
import { PremiumSumTwoCoverage } from './components/fields/PremiumSumTwoCoverage';
import { ConditionalPremiumSum } from './components/fields/ConditionalPremiumSum';
import { ConditionalExpression } from './components/metadata/ConditionalExpression';
import { AutomobiliaField } from './components/fields/AutomobiliaField';
import { SparePartsField } from './components/fields/SparePartsField';
import { ExpressionWithHint } from './components/metadata/ExpressionWithHint';
import { PIPMedicalLimitDriverSelector } from './components/fields/PIPMedicalLimitDriverSelector';
import { PIPAttendantCareSelector } from './components/fields/PIPAttendantCareSelector';
import { PIPBenefitCoordinationSelector } from './components/fields/PIPBenefitCoordinationSelector';
import { PIPWorkLossDriverSelector } from './components/fields/PIPWorkLossDriverSelector';
import { PIPSelector } from './components/fields/PIPSelector';
import { PIPWorkLossSelector } from './components/fields/PIPWorkLossSelector';
import { QuestionsFiltered } from './components/fields/QuestionsFiltered';
import { ModelYearPicker } from './components/fields/ModelYearPicker';
import { ConditionalField } from './components/fields/ConditionalField';
import { CCPANotice } from './components/metadata/CCPANotice';
import { SwitchPremiumSum } from './components/fields/SwitchPremiumSum';
import { LocationsForm } from './components/forms/LocationsForm';

export default {
  CollectorMake,
  DriverListSelectCapital,
  UMPDLimitSelector,
  PDLimitSelector,
  UMBILimitSelector,
  UIMBILimitSelector,
  MPLimitSelector,
  ILBLimitSelector,
  PremiumSumTwoCoverage,
  ConditionalPremiumSum,
  ConditionalExpression,
  AutomobiliaField,
  SparePartsField,
  ExpressionWithHint,
  PIPMedicalLimitDriverSelector,
  PIPAttendantCareSelector,
  PIPBenefitCoordinationSelector,
  PIPWorkLossDriverSelector,
  PIPSelector,
  PIPWorkLossSelector,
  BILimitSelector,
  QuestionsFiltered,
  ModelYearPicker,
  UMSUMLimitSelector,
  CollisionDeductibleSelector,
  ConditionalField,
  CCPANotice,
  SwitchPremiumSum,
  LocationsForm,
};